const shared = {
  caliberTitle: '口径版本与数据截止日期',
  caliber: '口径',
  through: '截至',
  batch: '批次',
  denominator: '分母',
  loading: '正在读取采样数据…',
  readFailure: '这块数据没能取回来',
  readFailureClarification: '这不代表企业在 AI 里没有出现——只是这次读取失败了，两者不能混为一谈。',
  permissionTitle: '你暂时不能访问这个项目',
  permissionBody: '请切换到已获授权的项目，或请项目负责人为你开通权限。',
  retry: '重新读取',
  closeEvidence: '关闭证据',
  provenance: {
    real: '真实数据',
    construct: '构造数据',
    placeholder: '占位判据',
  },
  session: {
    secureSession: 'NAVIGATOR ACCESS',
    contextTitle: '进入领航者。',
    contextBody: '安全地继续到你的企业空间。',
    pathLabel: '账户建立进度',
    pathOneTitle: '验证邮箱',
    pathOneBody: '一次性登录链接只会发送给企业空间中的有效成员。',
    pathTwoTitle: '选择或创建企业',
    pathTwoBody: '当前会话只能读取该企业分配给你的项目。',
    pathThreeTitle: '开始工作',
    pathThreeBody: '诊断、行动与成果会在不暴露内部凭据的前提下恢复。',
    memberEntry: '开始使用',
    requestTitle: '用邮箱继续。',
    requestLead: '已有成员直接登录；新用户验证后创建企业空间。',
    afterLogin: '登录后',
    destination: {
      diagnosis: '返回诊断',
      results: '返回成果',
      action: '返回行动',
      research: '返回企业研究',
    },
    emailLabel: '工作邮箱',
    invalidEmail: '请输入有效的工作邮箱。',
    sendLink: '继续',
    sending: '正在发送…',
    privacyTitle: '仅限企业成员。',
    privacyBody: '邮箱仅用于登录和必要的账户通知。',
    checkEyebrow: '申请已受理',
    checkTitle: '请检查你的邮箱',
    checkLead: '安全链接已经发出。请在此设备上打开邮件，继续进入领航者。',
    linkLifetime: '链接 15 分钟内有效',
    resendShort: '重新发送',
    changeEmail: '更换邮箱',
    verifyingEyebrow: '正在核验成员身份',
    verifyingTitle: '正在打开企业空间',
    verifyingLead: '系统正在将一次性链接兑换为受保护的浏览器会话。',
    expiredEyebrow: '链接不可用',
    expiredTitle: '这条登录链接已过期或已经使用',
    expiredLead: '请用同一个已获授权的工作邮箱申请新链接，项目数据没有发生变化。',
    requestNewLink: '申请新链接',
    problemEyebrow: '连接中断',
    problemTitle: '暂时无法申请登录链接',
    problemLead: '请检查网络后重试，企业空间中的数据没有发生变化。',
    chooseSpaceEyebrow: '企业空间',
    chooseSpaceTitle: '选择这次要进入的企业空间',
    chooseSpaceLead: '{email} 已获多个企业空间授权。选择后只会读取该空间的数据，进入后仍可随时切换。',
    openingSpace: '正在进入…',
    chooseSpaceFailed: '暂时无法进入这个企业空间，请重试。',
    createEyebrow: '邮箱已验证',
    createContextTitle: '一个身份，进入你所属的每一家企业。',
    createContextBody: '企业空间承载项目、成员、记忆与权益。',
    createTitle: '创建企业空间。',
    createLead: '填写基础信息。个人创业者可使用品牌或工作室名称。',
    verifiedIdentity: '已验证',
    orgName: '企业 / 品牌 / 团队名称',
    region: '主要经营地区',
    website: '官网或主页',
    optional: '选填',
    terms: '我有权代表该企业，并同意服务条款与隐私政策。',
    createButton: '创建企业空间',
    creatingWorkspace: '正在创建…',
    regionCN: '中国大陆',
    regionGlobal: '其他国家或地区',
    regionHK: '中国香港',
    regionTW: '中国台湾',
    regionJP: '日本',
    regionKR: '韩国',
    createBoundary: '注册不会自动开通付费功能。',
    companyNameInvalid: '请输入企业、品牌或团队名称。',
    termsRequired: '请先同意服务条款与隐私政策。',
    registrationFailed: '暂时无法创建企业空间，请重试。',
    footerSecurity: '一次性链接 · 受保护 Cookie · 租户隔离',
    footerHelp: '需要帮助 · hello@monolithos.ai',
  },
} as const

export default shared
